import React from 'react';
import {
    useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";
import PositionsMutateSingleVoyage from "@containers/singleVoyage/mutateVoyage/position/PositionsMutateSingleVoyage";
import {
    useViewContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/viewContext/hooks/useViewContextMutateSingleVoyage";

interface IProps {
    /** line opacity; the template editor dims it so highlighted stretches stand out */
    opacity?: number
}

const PositionsMapMutateSingleVoyage = ({opacity}: IProps) => {

    const {positions} = useRootContextMutateSingleVoyage()

    const {mode} = useViewContextMutateSingleVoyage()

    if (!positions?.length) {
        return <></>
    }

    if (mode === 'changeCorrectionPoints') {
        return
    }

    return (
        <PositionsMutateSingleVoyage opacity={opacity}/>
    );
};

export default PositionsMapMutateSingleVoyage;